<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'
import CsImage from '@/onenetwork/components/csimage/CsImage.vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  return (typeof props.data === 'string') ? props.data : ''
})

const width = computed(() => {
  return props.cellConfig?.config?.width || '60px'
})

const height = computed(() => {
  return props.cellConfig?.config?.height || '60px'
})

const borderRadius = computed(() => {
  return props.cellConfig?.config?.borderRadius || '4px'
})

</script>

<template>
  <div class="table-cell">
    <div class="thumb" v-if="value" :style="`width: ${width}; height: ${height}; border-radius: ${borderRadius}`">
      <cs-image :src="value" alt=""/>
    </div>
    <div class="thumb" :style="`width: ${width}; height: ${height}; border-radius: ${borderRadius}`" v-else>
      <Icon icon="material-symbols-light:photo-prints" :width="width" :height="height" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.table-cell{
  color: #d3d3d3;
  .thumb{
    overflow: hidden;
    border-radius: 8px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
